import { useEffect, useId, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateInboxDefaultUserTypes } from "../../Providers/main";
import { setDefaultUserTypes } from "../../Redux/inbox/actions";

import { ClientTable, SearchInput, useClientSearch } from "./ClientSearchComponents";

export const DocumentReviewTo = () => {
  const dispatch = useDispatch();
  const defaultUserTypes = useSelector((state) => state.inbox.defaultUserTypes);

  const handleDefaultUserType = (id) => {
    const updatedUserTypes = (defaultUserTypes || []).map((userType) =>
      userType?.id === id ? { ...userType, status: !userType.status } : userType
    );
    const updatedUserType = updatedUserTypes.find((userType) => userType?.id === id);

    dispatch(setDefaultUserTypes(updatedUserTypes));
    updateInboxDefaultUserTypes(id, updatedUserType?.status);
  };

  return (
    <div
      className="document-review-to d-flex w-100 align-items-center flex-wrap"
      style={{
        background: "var(--primary-80)",
        minHeight: "25px",
        padding: "2px 5px",
      }}
    >
      <p className="fw-600 text-white wp-nowrap p-r-5">Document Review To:</p>
      <div className="client-search d-flex justify-content-start flex-wrap inbox-labels">
        {(defaultUserTypes || []).map((userType) => (
          <label
            key={userType?.id}
            className="inbox-checkbox-container mb-0 d-flex align-items-center cursor-pointer"
          >
            <input
              className="me-2 checkbox cursor-pointer"
              checked={Boolean(userType?.status)}
              type="checkbox"
              onChange={() => handleDefaultUserType(userType?.id)}
            />
            <span className="text-white fw-600 cursor-pointer">{userType?.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

const ClientSearch = ({ setError, fetchPageDetails, setLoading, showAttachButton = false }) => {
  const searchInputId = useId();
  const searchInputRef = useRef(null);
  const searchContainerRef = useRef(null);
  const { searchTerm, setSearchTerm, searchResults, setSearchResults, isLoading, error } =
    useClientSearch();

  useEffect(() => {
    if (!searchTerm) return;

    const handleClickOutside = (event) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setSearchTerm("");
        setSearchResults([]);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside, true);
    return () => document.removeEventListener("pointerdown", handleClickOutside, true);
  }, [searchTerm, setSearchTerm, setSearchResults]);

  return (
    <div
      ref={searchContainerRef}
      className="client-search-container document-case-search-container document-case-search-at-bottom table--no-card rounded-0 border-0 doc-pop-overflow-visible min-height-0"
    >
      <div className="client-search document-viewer-control-row">
        <label className="document-viewer-control-label" htmlFor={searchInputId}>
          Move to New Case:
        </label>
        <SearchInput
          id={searchInputId}
          inputRef={searchInputRef}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="document-search-text-color document-case-search-input"
          placeholder="Move This Document to a Different Case by Typing the First Three Letters of a Client's First, Middle or Last Name"
        />
        {showAttachButton && (
          <button
            type="button"
            className="btn btn-success height-25 d-flex align-items-center justify-content-center"
            style={{ flexShrink: 0, padding: "0 10px", fontSize: "14px", fontWeight: 600 }}
            onClick={() => searchInputRef.current?.focus()}
          >
            Attach This Document to a Case
          </button>
        )}
      </div>
      {searchTerm.length > 0 && (
        <div
          className="document-case-search-results"
          role="region"
          aria-label="Matching cases"
          tabIndex={0}
        >
          <ClientTable
            recs={searchResults}
            isLoading={isLoading}
            error={error}
            searchTerm={searchTerm}
            setError={setError}
            fetchPageDetails={fetchPageDetails}
            setLoading={setLoading}
            setSearchResults={setSearchResults}
            setSearchTerm={setSearchTerm}
            assignTaskOnLink={showAttachButton}
          />
        </div>
      )}
    </div>
  );
};

export default ClientSearch;
